import {useState} from 'react';
import List from '@mui/material/List';
import { Typography, Box, Paper, Divider } from '@mui/material';
import VitalsListItems from './VitalsListItems';

export default function VitalsList({ pet = null}) {

  const [listEmpty, setListEmpty] = useState(true);

  return(
      <Paper 
        elevation={3} 
        sx={{ 
          p: 2, 
          borderRadius: 2, 
        }}
      >
      <Typography variant="h6">Latest Vitals</Typography>
      <br />
      {listEmpty ? 
        <Divider variant="fullWidth" component="li">
          <Typography variant="caption" color="text.secondary">
            no vitals
          </Typography>
        </Divider>
      : null}
      <Box sx={{
        maxHeight: 300,
        overflow: "auto"
      }}>
        <List >
          <VitalsListItems
            pet={pet}
            mode='pet'
            setListEmpty={setListEmpty}
          />
        </List>
      </Box>
      </Paper>
  );
}